export const SET_COURSES = "SET_COURSES";
export const SET_ASSIGN_COURSE = "SET_ASSIGN_COURSE";
export const SET_ASSIGNED_COURSES = "SET_ASSIGNED_COURSES";
export const SET_UNASSIGN_COURSE = "SET_UNASSIGN_COURSE";
export const SET_LOADING = "SET_LOADING";

export const SET_PARENT_URL = "SET_PARENT_URL";
